import { render, staticRenderFns } from "./addMetaTag.vue?vue&type=template&id=44664f70"
import script from "./addMetaTag.vue?vue&type=script&lang=js"
export * from "./addMetaTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports